// extracted by mini-css-extract-plugin
module.exports = {"message":"style_message__3ivex"};